import styled from "styled-components";

export const Container = styled.div`
  font-family: Sora;
  width: 6.86rem;

  margin-right: 2rem;

  Button {
    background: #ffffff;
    border: 1.97029px solid #d4d6da;
    box-sizing: border-box;
    border-radius: 8.44412px;
    font-family: Sora;
    color: #7e858f;
    margin-left: 2rem;
  }
  svg {
    fill: #7e858f;
    margin-right: 0.4rem;
  }
`;

export const ActivedButtonContainer = styled.div`
  position: relative;
  width: 13.5rem;

  margin-left: 2rem;
  z-index: 100;
  button {
    font-family: Sora;
  }
  button:nth-child(1) {
    color: #42464c;

    path {
      stroke: #42464c;
    }

    svg {
      margin-right: 0.4rem;
    }
  }
`;

export const ActiveMenu = styled.div`
  position: absolute;
  width: 13.5rem;

  background: #ffffff;
  border-radius: 8.46812px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 5.64541px 11.2908px rgba(20, 20, 20, 0.3);
`;

export const MenuNone = styled.div`
  width: 100%;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #eff1f5;
  cursor: pointer;

  :hover {
    background: #eff1f5;
  }
`;
export const MenuText = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.81rem;
  line-height: 1.1rem;
  color: #212326;
  margin-left: 1rem;
`;
export const MenuUnmarked = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  background-color: #eff1f5;
`;
export const MenuCheck = styled.div`
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;

  path {
    stroke: #40e5a0;
  }
`;

export const MenuOption = styled.div`
  width: 100%;
  height: 2.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  :hover {
    background: #eff1f5;
  }
  svg {
    margin-right: 1rem;
  }
`;
